/** /admin/reports/payables — Sundry Creditors (Payables). */
import { Users2 } from 'lucide-react';
import { BalancesReport } from '../../components/BalancesReport';
export default function PayablesPage() {
  return <BalancesReport title="Payables" endpoint="/api/tally-import/outstanding/payables" icon={Users2} emptyText="No sundry creditors with an outstanding balance." />;
}
